(function($, Global) {
    var MenuRightComponent = function() {
        this.isShown = false;
        this.isShownFilter = false;
    };

    MenuRightComponent.prototype.initEvents = function() {
        this.publishers();
    }

    MenuRightComponent.prototype.publishers = function() {
        var self = this;

        $(document).on('click', '[data-toggle="menuRight"]', function (e) {
            return self.isShown ? self.hide(e, false) : self.show(false)
        });

        $(document).on('click', '[data-toggle="menuRightFilter"]', function (e) {
            return self.isShownFilter ? self.hide(e, true) : self.show(true)
        });

        $(document).on('click', '.menuright-backdrop', function (e) {
            return self.hide(e)
        });
    }

    MenuRightComponent.prototype.show = function (isFilterMenu) {
        if (!isFilterMenu && this.isShown) return;
        if (isFilterMenu && this.isShownFilter) return;

        var menuright = isFilterMenu ? 'menuright-filter' : 'menuright';
        $('body, .' + menuright +', .menuright-backdrop').addClass('in');

        if (isFilterMenu) this.isShownFilter = true;
        else this.isShown = true
    }

    MenuRightComponent.prototype.hide = function (e, isFilterMenu) {
        if (!isFilterMenu && !this.isShown) return;
        if (isFilterMenu && !this.isShownFilter) return;
        var menuright = isFilterMenu ? 'menuright-filter' : 'menuright';
        $('body, .' + menuright +', .menuright-backdrop').removeClass('in');

        if (isFilterMenu) {
            this.isShownFilter = false;
            if ($('.page .sector-list.show-more').exists()) {
                $('.more-sector').removeClass('d-none');
                $('.page .sector-list').removeClass('show-more');
            }
        }
        else this.isShown = false;

    }

    Global.MenuRightComponent = MenuRightComponent;
}(jQuery, window));